import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';

interface StorageUploadResponse {
  fileName?: string;
}

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly http = inject(HttpClient);

  uploadFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.set('file', file);

    return this.http.post<StorageUploadResponse>(`${API_BASE_URL}/storage`, formData).pipe(
      map((response) => {
        const fileName = response?.fileName?.trim();
        if (!fileName) {
          throw new Error('Réponse upload invalide.');
        }
        return fileName;
      })
    );
  }
}
